import React from 'react'
import { FormattedMessage } from 'react-intl'
import { StatsRow, StatCard, StatLabel, StatValue, ChartsRow, Wrapper, EmptyCard } from './style'
import Donutchartcard from '../Donutchartcard'
import ProgressSection from '../ProgressSection'
import { getChartState, toSegments } from '../../utils'

const StateTab = ({ monitoring, stateStatus, isDraft }) => {
  const { speciesBenchmarkCounts, ecoBenchmarkCounts } = monitoring?.biodiversity ?? {}

  const speciesChart = getChartState(speciesBenchmarkCounts)
  const ecosystemsChart = getChartState(ecoBenchmarkCounts)

  const speciesItems = monitoring?.biodiversity?.speciesItems || 0
  const ecoItems = monitoring?.biodiversity?.ecoItems || 0

  const hasSpecies = speciesItems > 0
  const hasEcosystem = ecoItems > 0
  const visibleChartsCount = (hasSpecies ? 1 : 0) + (hasEcosystem ? 1 : 0)

  const visibleStatsCount = visibleChartsCount

  return (
    <Wrapper>
      <ProgressSection
        percent={stateStatus?.progress}
        status={stateStatus?.status}
        labelId="monitoringStateEvaluationProgress"
        labelDefaultMessage="State evaluation progress: {percent}%"
        isDraft={isDraft}
      />

      {visibleStatsCount > 0 && (
        <StatsRow $columns={visibleStatsCount}>
          {hasSpecies && (
            <StatCard>
              <StatLabel>
                <FormattedMessage id="monitoringSpeciesTaxonomicGroups" defaultMessage="Species (taxonomic groups)" />
              </StatLabel>
              <StatValue>
                {speciesItems} <span>({monitoring?.biodiversity?.groupedSpecies || 0})</span>
              </StatValue>
            </StatCard>
          )}

          {hasEcosystem && (
            <StatCard>
              <StatLabel>
                <FormattedMessage id="monitoringEcosystems" defaultMessage="Ecosystems" />
              </StatLabel>
              <StatValue>{ecoItems}</StatValue>
            </StatCard>
          )}
        </StatsRow>
      )}

      {visibleChartsCount > 0 ? (
        <ChartsRow $columns={visibleChartsCount}>
          {hasSpecies && (
            <Donutchartcard titleId="monitoringSpecies" titleDefaultMessage="Species" segments={toSegments(speciesChart)} />
          )}
          {hasEcosystem && (
            <Donutchartcard
              titleId="monitoringEcosystemsChart"
              titleDefaultMessage="Ecosystems"
              segments={toSegments(ecosystemsChart)}
            />
          )}
        </ChartsRow>
      ) : (
        <EmptyCard>
          <FormattedMessage
            id="monitoringNoSpeciesOrEcosystems"
            defaultMessage="No species or ecosystems available for state evaluation"
          />
        </EmptyCard>
      )}
    </Wrapper>
  )
}

export default StateTab

